import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import _ from 'lodash';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { getIsGlobalUser } from '../../../features/loginSystem/selectors';
import {
  Button,
  ButtonGroup,
  FormControl,
  FormLabel,
  Grid
} from '@material-ui/core';

const VersionCommentContent = ({ state = {}, setState, languages }) => {
  const isGlobalUser = useSelector(getIsGlobalUser);
  const { formatMessage } = useIntl();
  const location = useLocation();
  const [isUpdate, setIsUpdate] = useState(true);
  const versionCommentHasError = !!state.versionCommentHasError && isUpdate;

  const handleToggle = value => {
    const shouldUpdate = value === 'yes';
    setIsUpdate(shouldUpdate);
    setState({
      versionCommentHasError: !shouldUpdate
    });

    if (value === 'no') {
      languages.map(itm => {
        _.set(state, `versionComment.${itm.code}`, '');
        setState(prev => ({
          versionComment: {
            [itm.code]: ''
          }
        }));
      });
    }
  };

  useEffect(() => {
    setState({ isUpdate });
  }, [isUpdate]);

  return (
    <>
      {!isGlobalUser && (
        <Grid container>
          <Grid item sm={10}>
            <FormControl component="fieldset" style={{ marginBottom: '1em' }}>
              <FormLabel
                component="legend"
                style={{ fontSize: '12px', fontWeight: 'bold' }}
              >
                <FormattedMessage
                  id="chooseNoOption"
                  defaultMessage="Choose NO option if you don't want co-workers to be notified about this update."
                />
              </FormLabel>
              <FormLabel
                component="legend"
                style={{
                  fontSize: '12px',
                  fontWeight: 'bold',
                  marginTop: '1em'
                }}
              >
                <FormattedMessage
                  id="chooseNoOption"
                  defaultMessage="This will remove Update notification in co-worker view."
                />
              </FormLabel>
            </FormControl>
          </Grid>
          <Grid item sm={2}>
            <ButtonGroup variant="outlined" style={{ marginTop: '10px' }}>
              <Button
                color={isUpdate ? 'primary' : 'default'}
                variant={isUpdate ? 'contained' : 'outlined'}
                onClick={() => handleToggle('yes')}
              >
                Yes
              </Button>
              <Button
                color={!isUpdate ? 'primary' : 'default'}
                variant={!isUpdate ? 'contained' : 'outlined'}
                onClick={() => handleToggle('no')}
              >
                No
              </Button>
            </ButtonGroup>
          </Grid>
        </Grid>
      )}
      <Typography variant="body1">
        <FormattedMessage id="prompt.contentVersionCommentText" />
      </Typography>
      {languages.map(({ code, name }) => {
        const value = _.get(state, `versionComment.${code}`, '');
        const error = versionCommentHasError && !value;
        const errorText = error
          ? formatMessage({
              id: 'prompt.contentVersionCommentMissingDataError'
            })
          : '';
        const label =
          languages.length > 1
            ? formatMessage(
                { id: 'prompt.contentVersionCommentTextFieldWithLangLabel' },
                { language: name }
              )
            : formatMessage({
                id: 'prompt.contentVersionCommentTextFieldLabel'
              });

        return (
          <TextField
            key={`version-comment/${code}`}
            id="filled-multiline-static"
            label={label}
            multiline
            required={isUpdate}
            disabled={!isUpdate}
            fullWidth
            rows="3"
            variant="filled"
            value={value}
            error={error}
            helperText={errorText}
            onChange={event => {
              setState({
                versionComment: {
                  ...state.versionComment,
                  [code]: event.target.value
                }
              });
            }}
            style={{ marginTop: '1em' }}
          />
        );
      })}
      <p style={{ marginBottom: 0 }}>
        <Typography variant="caption">
          {isGlobalUser ? (
            <FormattedMessage id="prompt.contentVersionCommentNoteGlobalUser" />
          ) : (
            <FormattedMessage id="prompt.contentVersionCommentNoteLocalUser" />
          )}
        </Typography>
      </p>
    </>
  );
};

const transformToDataApiFormat = (promptState = {}) => {
  let approvalData = {};
  _.forOwn(promptState.versionComment, (value, key) => {
    approvalData = {
      ...approvalData,
      [key]: { versionComment: value },
      isUpdateSelected: promptState.isUpdate
    };
  });
  return approvalData;
};

export default VersionCommentContent;
export { transformToDataApiFormat };
